/* tslint:disable */
export var icon = "\n<svg width=\"31\" height=\"31\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"currentColor\" fill-rule=\"nonzero\" d=\"M15.5 22h1V11.957l3.75 3.793L21 15l-5.043-5L11 15l.75.75 3.75-3.878z\"/></svg>\n";
//# sourceMappingURL=thin-arrow-up.svg.js.map